import React, { PureComponent } from 'react';
import ColumnTitle from './ColumnTitle';

class TableHeader extends PureComponent {
    constructor(props) {
        super(props);

    }

    render() {
        const { column, columnIndex, orderColumn, columnaActivaOrdenamiento } = this.props;
        let icon = false;
        if (this.props != undefined) {
            if (column != undefined) {
                icon = column[columnIndex].state
            }
        }


        return (
            <thead>
                <tr>
                    <th className='configuracionProcesos__registroCabecera' style={{ width: "121px" }}>
                        <ColumnTitle title="TIPO DE PROCESO" columnIndex={0} order={(columnIndex == 0)} icon={icon} orderColumn={orderColumn} columnaActivaOrdenamiento = {columnaActivaOrdenamiento} />
                    </th>
                    <th className='configuracionProcesos__registroCabecera'>
                        <ColumnTitle title="NOMBRE" columnIndex={1} order={(columnIndex == 1)} icon={icon} orderColumn={orderColumn} columnaActivaOrdenamiento = {columnaActivaOrdenamiento} />

                    </th>
                    <th className='configuracionProcesos__registroCabecera'>
                        <ColumnTitle title="DESCRIPCIÓN" columnIndex={2} order={(columnIndex == 2)} icon={icon} orderColumn={orderColumn} columnaActivaOrdenamiento = {columnaActivaOrdenamiento}/>

                    </th>
                    <th className='configuracionProcesos__registroCabecera' style={{ width: "122px" }}>
                        <ColumnTitle title="PERIODICIDAD" columnIndex={3} order={(columnIndex == 3)} icon={icon} orderColumn={orderColumn} columnaActivaOrdenamiento = {columnaActivaOrdenamiento}/>

                    </th>
                    <th className='configuracionProcesos__registroCabecera procesamientoParcial' style={{ width: "150px" }}>
                        <ColumnTitle title="PROCESAMIENTO PARCIAL" columnIndex={4} order={(columnIndex == 4)} icon={icon} orderColumn={orderColumn} columnaActivaOrdenamiento = {columnaActivaOrdenamiento}/>
                    </th>
                    <th>
                    </th>
                        <th style={{paddingRight: "20px"}}>
                    </th>
                </tr>
            </thead >
        );
    }
};

export default TableHeader;